const Tactic = require('../../entities/Tactic');
const { Age }  = require("../Constants");
const TacticNames = require("../Names/TacticNames");

class ClassicArmy extends Tactic {
    constructor() {
        super(
            Age.Age2,
            TacticNames.ClassicArmy,
            [2, 2, 0],
            "8(4)",
            {}
        )
    }
}

module.exports = ClassicArmy;